export default "__VITE_ASSET__CdT99pn7__"